/**
 * Pushes 3D viewer events to `window.dataLayer` for GTM → GA4.
 * Event names match docs/3D_VIEWER_GA4_EVENTS.md (viewer_*).
 */
export function pushViewerEvent(eventName, params = {}) {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    const payload = { event: eventName };
    Object.entries(params || {}).forEach(([k, v]) => {
        if (v !== undefined && v !== null) payload[k] = v;
    });
    try {
        window.dataLayer.push(payload);
    } catch (_) {
        /* ignore */
    }
}
